import { EventEnum } from 'features/Events/types/eventData';

// Order of events in Events Chart (reverse)
export const events = [
  {
    event: EventEnum.Sync,
  },
  {
    event: EventEnum.Error,
  },
  {
    event: EventEnum.Skip,
  },
  {
    event: EventEnum.Filler,
  },
  {
    event: EventEnum.Ad,
  },
  {
    event: EventEnum.Play,
  },
];
